import React, { useState, useRef, useEffect } from "react";
import { IoIosArrowForward } from "react-icons/io";
import { MdArrowDropDown } from "react-icons/md";
import { FaExternalLinkAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const ManageLayoutModal = () => {
  const translation = useSelector((state) => state.root.translation);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const toggleDropdown = () => {
    setDropdownVisible((prev) => !prev);
  };

  const safeJsonParse = (item, defaultValue) => {
    try {
      return JSON.parse(item) || defaultValue;
    } catch (e) {
      return defaultValue;
    }
  };

  const permissions = safeJsonParse(localStorage.getItem("permissions"), null);
  const roleTitle = localStorage.getItem("roleTitle");
  const roleTitleAdmin = localStorage.getItem("roleTitleAdmin");

  const hasPermission = (permissionKey) => {
    return (
      roleTitle === roleTitleAdmin ||
      (Array.isArray(permissions) &&
        permissions.some(
          (p) =>
            p.Module &&
            p.Permission &&
            p.Module.toLowerCase() === permissionKey &&
            p.Permission.toLowerCase() === "view"
        ))
    );
  };

  const pages = [
    { pageName: translation?.operations || "Operations", objName: "operations" },
    { pageName: translation?.marketing || "Marketing", objName: "marketing" },
    { pageName: translation?.staffing || "Staffing", objName: "staffing" },
    { pageName: translation?.analytics || "Analytics", objName: "analytics" },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="profile-container" ref={dropdownRef}>
      <div className="manage-dropdown" onClick={toggleDropdown}>
        <div className="manage-top">
          <span>{translation?.manage || "Manage"}</span>
          <span>
            <IoIosArrowForward />
          </span>
          <span> {translation?.layouts || "Layouts"}</span>
        </div>
        <h6>
          {translation?.visit_platform || "Visit Platform"} <MdArrowDropDown />
        </h6>
      </div>

      {dropdownVisible && (
        <div className="manage-dropdown-content">
          <div className="manage-header">
            <h5>{translation?.overview || "Overview"}</h5>
            <div className="all-layouts">{translation?.all_layouts || "All Layouts"}</div>
          </div>
          <div className="manage-body-content">
            <div className="personalize-layout">
              <Link to="/admin-dashboard">
                {translation?.customize_layout || "Customize Layout"}
              </Link>
            </div>
            <ul>
              {pages
                .filter((page) => hasPermission(page.objName)) // Only show pages with permission
                .map((page, index) => (
                  <li key={index}>
                    <Link to={`/${page.objName}`}>
                      {page.pageName}
                      <FaExternalLinkAlt />
                    </Link>
                  </li>
                ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManageLayoutModal;
